module.exports = require("@material-ui/icons/FastForward");